/** @copy-from https://gitlab.poski.com/poskireal/poskireal.cz/-/blob/b6fad8efb2f562b8c5b543332ff02b682053616f/frontend/CID/poski/v8.1/klasik/js/address-suggest.js */
document.addEventListener("DOMContentLoaded", function (event) {
    const token = document.querySelector('#js-address-suggest-token').value;
    const searchTextInput = document.querySelector('.js-address-suggest');
    const krajElement = document.querySelector('#id_kraj2');
    const okresElement = document.querySelector('#okres');
    const mestoElement = document.querySelector('#mesto');
    const uliceElement = document.querySelector('#ulice');
    const cpElement = document.querySelector('#c_p');
    const ruianElement = document.querySelector('input[name="ruianCode"]');

    const getLocations = async ({}, processSuggest) => {
        const url = new URL('/' + window.PR_DIR + '/addressSuggest.php', window.location.origin);
        url.searchParams.set('token', token);
        url.searchParams.set('text', searchTextInput.value);
        if (searchTextInput.getAttribute('data-filter-okres')) {
            url.searchParams.set('okres', searchTextInput.getAttribute('data-filter-okres'));
        }
        if (searchTextInput.getAttribute('data-types')) {
            let types = searchTextInput.getAttribute('data-types').split(',');
            types.forEach((type) => {
                url.searchParams.append('types[]', type);
            })
        }
        try {
            const res = await fetch(url);
            const data = await res.json();
            if (data.status === 'success') {
                if (typeof(data.locations) !== 'undefined' && data.locations && data.locations.length) {
                    return processSuggest(data.locations);
                } else {
                    return processSuggest([{label: 'Adresa nebyla nalezena.', ruian_kod: 0}]); // auto-complete.js (vanila.js, ne JQuery) knihovna neumí hezky zobrazit hlášku o tom, že nebylo nic nalezeno.
                }
            } else if (data.status === 'error') {
                alert('Nepodařilo se nalézt adresy: ' + data.msg);
                console.error(data.msg);
            } else {
                alert('Nepodařilo se nalézt adresy, prosím, kontaktujte správce webu.');
                throw new Error();
            }
        } catch (error) {
            console.error(error);
            alert('Nepodařilo se nalézt nabídku, prosím, kontaktujte správce webu.');
            return processSuggest([]);
        }
    }

    const selectLocation = async (event, term, item) => {
        event.preventDefault();
        searchTextInput.value = term;
        let ruianCode = item.getAttribute('data-ruian-code');
        if (ruianCode === '0') { // Pokud kliknu na text s nenalezenou adresou, tak je ruianCode = '0'.
            return;
        }
        const params = new URLSearchParams({action: 'getDataByRuianCode', ruianCode: ruianCode});
        try {
            const res = await fetch(`/locationSearchAutocomplete.json?${params}`);
            const data = await res.json();
            if (data.status === 'success') {
                if (cpElement) {
                    cpElement.value = data?.AD_CisloDomovni;
                }
                if (uliceElement) {
                    uliceElement.value = data?.UL_Nazev;
                }
                if (mestoElement) {
                    mestoElement.value = data?.OB_Nazev;
                }
                if (okresElement) {
                    okresElement.value = data?.OK_Nazev;
                }
                if (krajElement) {
                    krajElement.value = data?.VC_Nazev;
                }
                if (ruianElement) {
                    ruianElement.value = data?.ruian_kod;
                }
            } else if (data.status === 'error') {
                alert('Nepodařilo se nalézt informace o vybrané adrese: ' + data.msg);
                console.error(data.msg);
            } else {
                throw new Error();
            }
        } catch (error) {
            console.error(error);
            alert('Nepodařilo se nalézt informace o vybrané adrese, prosím, kontaktujte správce webu.');
        }
    }

    const res = window.autoComplete({
        selector: '.js-address-suggest',
        minLength: 2,
        delay: 300,
        html: true,
        cache: 0,
        source: getLocations,
        onSelect: selectLocation,
        renderItem: function (item, search){
            let suggestion = item.label;
            let ruianCode = item.ruian_kod;
            // escape special characters
            return '<div class="autocomplete-suggestion" data-ruian-code="' + ruianCode + '">' + suggestion + '</div>';
        }
    });

});
